module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAASRJREFUaEPtlUEOgjAQRad4BT0VJzDGhJVsDIchbtCNiSGewFPBGahxoRET/aTjT4EM26HT/v+m/U4m/rmJn19MQGyCRsAIKB2wEVIaqF5uBNQWKhvMh0BZXdLEJWdxslSawl3upe18lxX59vbY6EXgcKobkZEf/mmNl3a/26z6Ao51M3r3fwkoq2uauG4CI+Tbzi+yIl/3R4g7uLzu83mFeB5xOxsBrr+4+/wJREvoj8T9xgISiJrQb4kbLiBmQv9DQLSE9v3EDSaA34G4f8A7EPd4eHcTgD3i/mEEuP7i7moCwUk9MGmRBLUAVVIPCCq+AE1Sj0FAcFIPTFo6AbQBu66+A+wDov4mADnErhsBtsOovxFADrHrRoDtMOpvBJBD7Podzj9jMQXt3EAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/icon-search.png
// module id = EQY5
// module chunks = 1